$(document).ready(function(){


  // faq JS

jQuery(".accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });

  });

// Product detail JS

			 jQuery(document).ready(function(){
  jQuery(".tab-btn").click(function(){
    var id_tab = jQuery(this).attr("data-val");

    // Remove 'active' class from all tab buttons and add to the clicked one
    jQuery(".tab-btn").removeClass("active");
    jQuery(this).addClass("active");
    
    // Remove 'active' class from all tab bodies and add to the target one
    jQuery(".product-tab-body").removeClass("active");
    jQuery(".product-tab-body." + id_tab).addClass("active");
  });
});

// Menu animation JS start

  document.addEventListener("DOMContentLoaded", function () {
    const menus = document.querySelectorAll(".mega-menu");

    menus.forEach(menu => {
      menu.addEventListener("toggle", function () {
        if (menu.open) {
          const items = menu.querySelectorAll(".mega-menu__list > li");

          items.forEach((item, index) => {
            item.style.animation = "none"; // Reset animation
            item.offsetHeight; // Trigger reflow
            item.style.animation = `menu-fade-up 0.4s ease forwards`;
            item.style.animationDelay = `${index * 60}ms`;
          });
        }
      });
    });
  });



// Menu Animation JS End




document.addEventListener("DOMContentLoaded", function () {
  const detailsElements = document.querySelectorAll(".product__accordion details");

  detailsElements.forEach((details) => {
    const summary = details.querySelector("summary");
    const content = details.querySelector(".accordion__content");

    // Remove default toggle behavior
    summary.addEventListener("click", (e) => {
      e.preventDefault();

      // If already open, close it
      if (details.hasAttribute("open")) {
        collapse(details, content);
      } else {
        // Close all others first
        detailsElements.forEach((el) => {
          if (el !== details && el.hasAttribute("open")) {
            collapse(el, el.querySelector(".accordion__content"));
          }
        });
        expand(details, content);
      }
    });
  });

  function collapse(details, content) {
    const contentHeight = content.scrollHeight;
    content.style.height = contentHeight + "px";

    requestAnimationFrame(() => {
      content.style.height = "0px";
    });

    content.addEventListener("transitionend", function handler() {
      details.removeAttribute("open");
      content.removeEventListener("transitionend", handler);
    }, { once: true });
  }

  function expand(details, content) {
    details.setAttribute("open", true);
    const contentHeight = content.scrollHeight;
    content.style.height = "0px";

    requestAnimationFrame(() => {
      content.style.height = contentHeight + "px";
    });

    content.addEventListener("transitionend", function handler() {
      content.style.height = "auto"; // Reset to auto for dynamic height
      content.removeEventListener("transitionend", handler);
    }, { once: true });
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector("#product-grid");
  let loadMoreBtn = document.querySelector("#LoadMore");

  if (!grid || !loadMoreBtn) return;

  loadMoreBtn.addEventListener("click", function (e) {
    e.preventDefault();
    loadMoreBtn.classList.add("loading");

    fetch(loadMoreBtn.href)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newItems = doc.querySelectorAll("#product-grid > li");
        newItems.forEach(item => grid.appendChild(item));

        const newBtn = doc.querySelector("#LoadMore");
        if (newBtn) {
          loadMoreBtn.href = newBtn.href;
        } else {
          loadMoreBtn.remove();
        }
      })
      .finally(() => {
        loadMoreBtn.classList.remove("loading");
      });
  });
});


document.addEventListener("DOMContentLoaded", function() {
    $('.collections-slider').owlCarousel({
      loop: true,
      margin: 20,
      nav:true, 
      slideSpeed : 3000,
      paginationSpeed : 400,
      autoplay:true,     
      dots: false,
      navText: ["<img src='https://cdn.shopify.com/s/files/1/0632/6213/0275/files/collection-slider-left.png?v=1746170918' alt='Previous'>", "<img src='https://cdn.shopify.com/s/files/1/0632/6213/0275/files/collection-slider-right.png?v=1746170918' alt='Next'>" ],
      responsive:{
        0:{ items:1 },
        600:{ items:2 },
        1000:{ items:3, margin: 10 },
        1100:{ 
          items:3,
          margin: 10
        }
      }
    });
  });



 






